<template>
  <layout-component>
    <div class="banner banner-discover">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-9 title-wrapper">
            <h1 class="left-bullet pb-1 pb-lg-0" v-html="$t('title-banner')"></h1>
          </div>
        </div>

        <div class="row mb-1 mb-lg-4">
          <div class="col-md-12">
            <div class="img-wrapper">
              <div class="noise">
                <b-img src="/storage/img/pic/pic-discover-01-new.webp" alt="Sonotron building" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-discover">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center mb-3 mb-lg-5">
          <div class="col-md-6">
              <p class="h4-style bottom-cut" v-html="$t('title-01')"></p>
              <p>{{'text-01'|t}}</p>
              <p>{{'text-02'|t}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2 mb-lg-0">
            <h2 v-html="$t('title-02')"></h2>
          </div>
        </div>
        <div class="row d-md-flex align-items-md-center mb-3 mb-lg-5 wide-left-discover-wrapper">
          <div class="col-md-5">
            <div class="wide-left wide-left-discover d-none d-md-block">
              <div class="noise">
                <b-img src="/storage/img/pic/pic-discover-02.webp" alt="discover sonotron" />
              </div>
            </div>
          </div>
          <div class="wide-left col-md-7">
            <div class="noise">
              <b-img src="/storage/img/pic/pic-discover-03.webp" alt="discover sonotron" />
            </div>
          </div>
        </div>

        <div class="row d-md-flex justify-content-md-center mb-3 mb-lg-5">
          <div class="col-md-6">
              <h2 v-html="$t('title-03')" class="br-title bottom-cut"></h2>
              <p>{{'text-03'|t}}</p>
          </div>
        </div>
      </div>

      <div class="container block-points pb-4 pb-lg-5">
          <div class="row d-flex align-items-center">
              <div class="col-md-5">
                <div class="noise">
                  <b-img src="/storage/img/pic/pic-discover-04.webp" alt="discover sonotron" />
                </div>
              </div>

              <div class="col-md-6 offset-md-1 offset-lg-1 col-lg-4 mt-15">
                  <p class="h4-style bottom-cut mt-2 mt-md-2 mt-lg-4" v-html="$t('title-04')"></p>

                  <p>{{'text-04' | t }}</p>
              </div>
          </div>

          <div class="row">
              <div class="col-md-6 col-lg-4">
                  <p class="h4-style bottom-cut mt-2 mt-md-4 mt-lg-5" v-html="$t('title-05')"></p>
                  <p>{{'text-05'|t}}</p>
              </div>

              <div class="col-md-6 col-lg-4 offset-lg-2">
                  <p class="h4-style bottom-cut mt-2 mt-md-4 mt-lg-5" v-html="$t('title-06')"></p>
                  <p>{{'text-06'|t}}</p>
              </div>
          </div>
      </div>

      <div class="banner-prefooter banner-prefooter-discover noise">
          <div class="container">
              <p class="h2-style">
                  <span v-html="$t('big-cta-prefooter')"></span>
                  <router-link class='btn-link btn-link-big left-bullet' to='/book' exact v-html="$t('view-our-spaces')"></router-link>
              </p>
          </div>
      </div>
    </div>

  </layout-component>
</template>

<script>
    export default {
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
        if ( $( '.banner-prefooter .title-anim-wrapper' ).is( ':in-viewport' ) ) {
          $('.banner-prefooter').addClass('in-viewport');
        }
      }
    }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Meet</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>Sonotron</span></span>",
        "title-01": "The people’s studio",
        "text-01": "Our mission is to dissolve the many obstacles that creatives face. Affordable space continues to be a barrier limiting productivity & opportunity within the music & sound industries.",
        "text-02": "Amid rising real-estate costs, Sonotron promises accessible rates & flexible timeframes that work for everyone.",
        "title-02": "<span class='title-anim-wrapper'><span class='title-anim td'>Time-sharing</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>plug-&-play music</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>studios in Differdange</span></span>",
        "title-03": "<span class='title-anim-wrapper'><span class='title-anim td'>Championing</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>the creative</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>industries</span></span>",
        "text-03": "When we launched 1535° in 2013, there were whispers of the region’s creative industries. Luxembourg now recognizes them as assets & these professions are moving from the shadows to the spotlight. We want Sonotron to strengthen the music & sound industries in the same way – by facilitating, unifying & promoting their efforts.",
        "title-04": "Facilitate creative work",
        "text-04": "Provide accessible studio spaces & recording resources to all, so professionals can experiment & produce finished products at a low cost; students can interact with music & sound in a high-quality environment & any member of the public can fulfill the urge to create.",
        "title-05": "Unify the community",
        "text-05": "Sonotron, the people’s music & sound hub, brings together the region’s community of musicians & sound creators. Come face-to-face with inspiring projects & like-minded peers via communal spaces, happy hours & jam sessions.",
        "title-06": "Promote the music & sound industries",
        "text-06": "As our community of creators continues to grow & strengthen, Sonotron & its platform will showcase & announce emerging work through events, communications efforts & its physical presence.",
        "big-cta-prefooter": "<span class='title-anim-wrapper'><span class='title-anim td'>Come find</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>your sound.</span></span>",
        "view-our-spaces": "<span class='title-anim-wrapper'><span class='title-anim td-3'>View our spaces</span></span>"

      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Decouvrez</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>le Sonotron</span></span>",
        "title-01": "Le studio pour tous",
        "text-01": "Nous avons pour mission d’éliminer les nombreux obstacles à la créativité. L’accès à un espace abordable reste un frein à la productivité et à la saisie des occasions dans le monde de la musique et du son.",
        "text-02": "Malgré la hausse des coûts immobiliers, le Sonotron garantit des tarifs accessibles et des créneaux flexibles qui conviennent à tous.",
        "title-02": "<span class='title-anim-wrapper'><span class='title-anim td'>Time-sharing</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>et plug and play</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>a Differdange</span></span>",
        "title-03": "<span class='title-anim-wrapper'><span class='title-anim td'>Soutien des</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>industries</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>creatives</span></span>",
        "text-03": "Quand nous avons inauguré le 1535° en 2013, on commençait tout juste à parler des industries créatives de la région. Aujourd’hui, le Luxembourg les reconnaît comme des atouts et ces professions passent de l’ombre à la lumière. Nous souhaitons que le Sonotron renforce les industries musicale et sonore de la même façon, par la facilitation, l'association et la promotion de leurs actions.",
        "title-04": "Faciliter le travail creatif",
        "text-04": "des studios aménagés à la portée de tous. Les professionnels peuvent donc expérimenter et produire à faible coût. Les étudiants peuvent interagir avec la musique et le son dans un environnement de haute qualité. Le Sonotron est également ouvert à toute personne souhaitant s'exercer ou créer.",
        "title-05": "Unifier la communaute",
        "text-05": "Le Sonotron est un lieu dédié à la musique et au son, rassemblant la communauté des musiciens et des créateurs de sons de la région. Venez découvrir des projets stimulants et les esprits créatifs dans nos espaces communs, lors de happy hours et à l’occasion de jam sessions.",
        "title-06": "Promouvoir la musique et le son",
        "text-06": "Au fur et à mesure de la croissance de notre communauté de créateurs, le Sonotron et sa plateforme physique s’engagera à soutenir et mettre en lumière leur savoir-faire lors d’évènements dédiés.",
        "big-cta-prefooter": "<span class='title-anim-wrapper'><span class='title-anim td'>Venez trouver</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>votre son.</span></span>",
        "view-our-spaces": "<span class='title-anim-wrapper'><span class='title-anim td-3'>Voir nos espaces</span></span>"
      }
    }

  </i18n>
